<template>
<div class="m-box">
  <div class="m-box-header" v-if="title || $slots.header">
    <slot name="header">{{title}}</slot>
    <slot name="link"></slot>
  </div>
  <div class="m-box-content"><slot></slot></div>
</div>
</template>
<script>
export default {
  name: 'm-box',
  props: {
    title: String
  }
}
</script>
<style>
  .m-box {
    margin: 0 auto;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 3px;
    /* box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12); */
    width: 100%;
  }
  .m-box:last-child{
    margin-bottom: 0;
  }
  .m-box .m-box-header{
    padding: 10px 15px;
    font-size: 1.2rem;
  }
  .m-box .m-box-content{
    padding: 15px;
  }
  .m-box.has-el-form .m-box-content{
    padding-bottom: 0;
  }
  .m-box .m-box-content::before,
  .m-box .m-box-content::after {
    content: "";
    display: table;
    clear: both;
  }
  .m-box .m-box-header + .m-box-content {
    padding-top: 0px;
  }
</style>
